<template>
  <v-app id="photos">
    <v-app-bar app dark dense color="primary">
      <v-toolbar-title>Censo MKD</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title>Id Resultado: {{ idresultado }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title>Encuesta: {{ encuesta }}</v-toolbar-title>
    </v-app-bar>
    <v-content>
      <v-container fluid>
        <v-card class="elevation-5">
          <v-card-text v-for="item in respuestas" :key="item.idexterno">
            <v-row align="center" justify="center">
              <span class="headline">{{ item.idexterno + ' - ' + item.nombre }}</span>
            </v-row>
            <v-row align="center" justify="center">
              <img :src="item.respuesta" style="width:100%;max-width:600px;"/>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
        {{ message }}
      </v-snackbar>
    </v-content>
    <v-footer app>
    </v-footer>
  </v-app>
</template>

<script>
import services from '@/utils/services'

export default {
  name: 'photos',
  data: () => ({
    loading: false,
    error: false,
    message: '',
    resultado: '',
    idresultado: '',
    encuesta: '',
    respuestas: []
  }),
  mounted () {
    this.resultado = this.$route.query.id
    this.getPhotos()
  },
  methods: {
    getPhotos() {
      this.loading = true
      setTimeout(() => {
        let params = {
          id: this.resultado
        }
        this.axios.get(services.routes.photos, { params })
          .then(response => {
            let res = response.data
            if (res.correcto) {
              this.idresultado = res.data.idresultado
              this.encuesta = res.data.encuesta
              this.respuestas = res.data.respuestas
            } else {
              this.error = true
              this.message = res.mensaje
            }
          })
          .catch(error => {
            console.log(error)
            this.error = true
            this.message = 'El servicio no se encuentra disponible en estos momentos'
          })
          .finally(() => {
            this.loading = false
          })
      }, 300)
    }
  }
}
</script>
